import { apiFetch } from './utils/api';
// const mockedFamily = require('./mocks/v1/wealth-plan/family.json');

export const family = {
  get: async () => {
    const options = {
      method: 'GET',
    };

    const url = '/v1/wealth-plan/family';

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
